import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fileUrl = (path) => `${API}/files/${path}`;
export const errorText = (e) => e?.response?.data?.detail?.toString?.() || "Something went wrong. Please try again.";
export const publicGet = (path, params) => axios.get(`${API}${path}`, { params }).then((r) => r.data);
export const fmtDate = (iso) => new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export const getAnonId = () => {
  let id = localStorage.getItem("os_anon_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("os_anon_id", id);
  }
  return id;
};

// Sends the session token when signed in; works signed out for public endpoints.
export const useApi = () => {
  const { getToken } = useAuth();
  const tokenRef = useRef(getToken);
  tokenRef.current = getToken;
  return useCallback(async (method, path, data, params) => {
    const token = await tokenRef.current();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await axios({ method, url: `${API}${path}`, data, params, headers });
    return res.data;
  }, []);
};

export const useMe = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) { setMe(null); setLoading(false); return; }
    setLoading(true);
    api("get", "/me").then(setMe).catch(() => setMe(null)).finally(() => setLoading(false));
  }, [isLoaded, isSignedIn, api]);
  return { me, loading, isAdmin: me?.role === "admin" };
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const t = document.createElement("textarea");
    t.value = text;
    document.body.appendChild(t);
    t.select();
    document.execCommand("copy");
    t.remove();
  }
};
